import { normalizeAssignment } from '@scale/shared/assignmentJson/legacy/assignment-normalizer';
import _ from 'lodash';

/* eslint-disable complexity */

export const normalize = (object: $FIXME): $FIXME => {
  // for tasks, attempts, etc, return an object that can be adapted to pass into renderTask
  if (
    _.includes(
      ['subtask', 'task', 'taskattempt', 'taskreview', 'reviewerconfidence', 'testtask'],
      object.__t,
    )
  ) {
    if (object.__t === 'subtask' || object.__t === 'task' || object.__t === 'testtask') {
      if (object.__t === 'task') {
        let instruction = _.get(
          object.project,
          `paramHistory[${object.projectParamVersion}].instruction`,
        );
        if (instruction && object.instruction) {
          instruction = object.instruction + '\n' + instruction;
        } else {
          instruction = object.instruction;
        }
        return {
          ...normalizeAssignment(object),
          instruction,
        };
      }

      try {
        return normalizeAssignment(object);
      } catch (error) {
        console.debug(error);
        return {};
      }
    } else if (object.__t === 'taskattempt') {
      try {
        const subtask = normalizeAssignment(object.subtask || object.task);
        subtask.lintVerdict = object.confidenceScores?.lintVerdict;
        subtask.lintResults = object.confidenceScores?.lintResults;
        subtask.attemptId = object._id;
        subtask.reviewLevel = object.reviewLevel;
        return {
          ...object,
          subtask,
        };
      } catch (error) {
        return {
          ...object,
        };
      }
    } else if (object.__t === 'taskreview' && object.fixAttempt && object.fixAttempt._id) {
      return {
        ...object,
        subtask: normalizeAssignment(object.subtask),
        fixAttempt: normalize(Object.assign({ __t: 'taskattempt' }, object.fixAttempt)),
      };
    } else if (object.__t === 'taskreview' && object.taskAttempt && object.taskAttempt.fixAttempt) {
      return {
        ...object,
        subtask: normalizeAssignment(object.subtask),
      };
    } else if (object.__t === 'reviewerconfidence' && object.attempt && object.attempt.subtask) {
      return {
        ...object,
        subtask: normalizeAssignment(object.attempt.subtask),
      };
    }
  }
  return; // for non-tasks, don't need to do anything
};
